import type { HierarchyRectangularNode } from 'd3-hierarchy';

import {
  RECT_STROKE_WIDTH,
  MIN_CLUSTER_HEIGHT_WITH_VISIBLE_CHILDREN,
  MIN_CLUSTER_WIDTH_WITH_VISIBLE_CHILDREN,
} from '../constants.js';
import type { LeafNode } from '../types/guards/node-guards.js';

export const shouldDrawLeafNode = (
  leaf: HierarchyRectangularNode<LeafNode>,
) => {
  const { y0 = 0, y1 = 0, x0 = 0, x1 = 0 } = leaf.parent ?? {};

  const nodeHeight = Math.abs(y1 - y0);
  const nodeWidth = Math.abs(x1 - x0);

  const fitHeight =
    nodeHeight + RECT_STROKE_WIDTH >= MIN_CLUSTER_HEIGHT_WITH_VISIBLE_CHILDREN;

  const fitWidth =
    nodeWidth + RECT_STROKE_WIDTH >= MIN_CLUSTER_WIDTH_WITH_VISIBLE_CHILDREN;

  return fitHeight && fitWidth;
};
